import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { getCurrencies } from "../../../utils/get-currencies";
import { formatOptions } from "../../../utils/helpers";
import Select from "react-select";

interface AboutEditProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
}

const AboutEdit: React.FC<AboutEditProps> = ({
  control,
  errors,
  watch,
  setValue,
}) => {
  const [currencies, setCurrencies] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      const list = await getCurrencies();
      setCurrencies(list);
    })();
  }, []);

  const currencyList = formatOptions(currencies);

  return (
    <div className="font-Inter">
      <div className="space-y-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Data system in use by the department{" "}
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="erpModule"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.erpModule ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="ERP Module 1"
              />
            )}
          />
          {errors.erpModule && (
            <p className="text-red-500 text-xs mt-1">
              {errors.erpModule.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Name of the system developer <span className="text-red-500">*</span>
          </label>
          <Controller
            name="systemDeveloper"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.systemDeveloper ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Enter system developer name"
              />
            )}
          />
          {errors.systemDeveloper && (
            <p className="text-red-500 text-xs mt-1">
              {errors.systemDeveloper.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Date of first installation <span className="text-red-500">*</span>
          </label>
          <Controller
            name="dateInstalled"
            control={control}
            render={({ field }) => (
              <input
                type="date"
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.dateInstalled ? "border-red-500" : "border-gray-300"
                }`}
              />
            )}
          />
          {errors.dateInstalled && (
            <p className="text-red-500 text-xs mt-1">
              {errors.dateInstalled.message}
            </p>
          )}
        </div>

        <div className="flex items-start gap-4">
          <div className="flex-1 space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Currency <span className="text-red-500">*</span>
            </label>
            <Controller
              name="annualLicenseFeeCurrency"
              control={control}
              render={({ field }) => (
                <Select
                  options={currencyList}
                  placeholder="Select Currency..."
                  onChange={(selected) => field.onChange(selected?.value || "")}
                  value={
                    currencyList.find((opt) => opt.value === field.value) ||
                    null
                  }
                  className={
                    errors.annualLicenseFeeCurrency ? "react-select-error" : ""
                  }
                />
              )}
            />
            {errors.annualLicenseFeeCurrency && (
              <p className="text-red-500 text-xs mt-1">
                {errors.annualLicenseFeeCurrency.message}
              </p>
            )}
          </div>

          <div className="flex-1 space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Amount paid for annual license fees or maintenance{" "}
              <span className="text-red-500">*</span>
            </label>
            <Controller
              name="annualLicenseFee"
              control={control}
              render={({ field }) => (
                <input
                  type="number"
                  {...field}
                  className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors.annualLicenseFee
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  placeholder="Enter Annual License Fees"
                />
              )}
            />
            {errors.annualLicenseFee && (
              <p className="text-red-500 text-xs mt-1">
                {errors.annualLicenseFee.message}
              </p>
            )}
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Describe the main purpose of the system{" "}
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="systemPurpose"
            control={control}
            render={({ field }) => (
              <textarea
                {...field}
                rows={3}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.systemPurpose ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="e.g. Billing, NRW management, Payroll"
              />
            )}
          />
          {errors.systemPurpose && (
            <p className="text-red-500 text-xs mt-1">
              {errors.systemPurpose.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutEdit;
